import { getPlatformUrlParts } from '@acl-services/highbond-common';

const {
  protocol,
  appSubdomain,
  region: regionFromUrl,
  orgSubdomain,
  domain,
  domainSuffix,
  tld,
  isLocal,
  isDev,
  isStaging,
  isPreprod,
  isProduction,
  isGovCloud,
} = getPlatformUrlParts(window.location.origin, true);

const drSubdomainPrefix = '-uk';
const region = appSubdomain.endsWith(drSubdomainPrefix) ? 'us' : regionFromUrl;
const isLocalhost = isLocal || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
const nonUsRegionalSuffix = region !== 'us' ? `-${region}` : '';

const host = `${domain}${domainSuffix}.${tld}`;

const AppConfig = {
  homeUrl: `${protocol}://${orgSubdomain}.home${drSubdomainPrefix}${nonUsRegionalSuffix}.${host}`,
  launchpadUrl: `${protocol}://accounts${drSubdomainPrefix}.${host}`,
  loginUrl: `${protocol}://accounts${drSubdomainPrefix}.${host}/login`,
  oidcClientUrl: isLocalhost ? 'http://localhost:5173' : `${protocol}://oidc-${region}${drSubdomainPrefix}.${host}`,
  organizationsApiUrl: `${protocol}://organizations${drSubdomainPrefix}.${host}`,
  pendoMonitorScript: `${protocol}://monitor${nonUsRegionalSuffix}.${host}/v1/monitor.js`,
  isLocal,
  isDev,
  isStaging,
  isProduction,
  isProductionLike: isProduction || isPreprod,
  isGovCloud,
  region,
  orgSubdomain: isLocal ? 'test-org' : orgSubdomain,
  microFrontends: {
    'hb-global-navigator': {
      url: `${protocol}://web-components${drSubdomainPrefix}${nonUsRegionalSuffix}.${host}/global-navigator/index.js`,
    },
  },
  featureFlags: {
    emailNotificationExpiry: {
      enabled: !isProduction && !isGovCloud,
    },
  },
};

export default AppConfig;

export const AppRoutes = {
  ROOT_PATH: 'security-settings',
  UNAUTHORIZED: 'unauthorized',
  OIDC_CALLBACK: 'oidc/callback',
  LOGOUT_CALLBACK: 'logout',
  LOGIN_CALLBACK: 'login/callback',
};

export const PendoTracking = {
  NEW_USER_INVITATION_EXPIRY: 'organization-settings_new-user-invitation-expiry',
};
